/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menufullempty2Inputs */

const en_menufullempty2 = /** @type {(inputs: Menufullempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No menu yet. Upload photos or a PDF of your menu or enter it yourself.`)
};

const de_menufullempty2 = /** @type {(inputs: Menufullempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Speisekarte. Lade Fotos oder ein PDF deiner Karte hoch oder trag sie selbst ein.`)
};

/**
* | output |
* | --- |
* | "No menu yet. Upload photos or a PDF of your menu or enter it yourself." |
*
* @param {Menufullempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufullempty2 = /** @type {((inputs?: Menufullempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufullempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufullempty2(inputs)
	return de_menufullempty2(inputs)
});
export { menufullempty2 as "menuFullEmpty" }